import React from "react";

interface StraightLineProps {
  top?: number;
  bottom?: number;
  color?: string;
  height?: number;
}

const SingleLineDisplay: React.FC<StraightLineProps> = ({
  top = 8,
  bottom = 8,
  color = "rgba(235, 235, 235, 1)",
  height = 1,
}) => {
  return (
    <div
      style={{
        height: height,
        backgroundColor: color,
        width: '96%',
        margin: 'auto',
        marginTop: top,
        marginBottom: bottom
      }}
    />
  );
};

export default SingleLineDisplay;